import { getUser } from 'api/user';
import { create } from 'zustand';
import useAccountStore from './accountStore';

export interface UserProps {
  _id: string;
  fullName: string;
  email: string;
  dob: string;
  address: string;
  city: string;
  province: string;
  country: string;
  zipCode: string;
  phoneNumber: string;
  profileImage: string;
  isEmailVerified: boolean;
  type: 'admin' | 'investor';
  isPremium?: boolean;
  planType?: string;
  message?: string | null;
  announcement?: string | null;
  exchange: string;
}

export type User = Omit<UserProps, '_id'>;

interface UserStoreType {
  user: UserProps | null;
  errors: string[];
  clearErrors: () => void;
  clearUser: () => void;
  setUser: (data: UserProps) => void;
  fetchUser: (authToken: string) => Promise<void>;
}

const useUserStore = create<UserStoreType>((set) => ({
  user: null,
  errors: [],
  setUser: (data) => set((state) => ({ ...state, user: { ...data } })),
  fetchUser: async (authToken) => {
    if (!authToken) return;

    try {
      const res = await getUser();

      if (res?.data) {
        const userType = res.data.type;

        if (userType !== 'admin') {
          useAccountStore.getState().fetchAccount();
        }
        set((state) => ({ ...state, user: { ...res.data } }));
      }
    } catch (error: any) {
      const { errors } = error.response.data;
      errors.forEach((err: { error: string }) => {
        set((state) => ({ ...state, errors: [...state.errors, err.error] }));
      });
      console.log(error);
    }
  },
  clearErrors: () => set((state) => ({ ...state, errors: [] })),
  clearUser: () => set((state) => ({ ...state, user: null })),
}));

export default useUserStore;
